import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';
import SmsConversationProfile from '../components/SmsConversationProfile';
import { loadCareGuideAdmin } from '../../../../../state/modules/careGuidesAdmin/actions';
import { loadAdminPartnerClassPartnershipAdmin } from '../../../../../state/modules/adminPartnerClassesAdmin/actions';

const mapStateToProps = (state, ownProps) => {
  const careGuideId = ownProps.smsConversation
    ? ownProps.smsConversation.care_guide_id
    : null;
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  const adminPartnerClass = state.adminPartnerClassesAdmin.getIn([
    'adminPartnerClassesAdmin',
    partnershipId,
  ]);

  const careGuide = state.entities.getIn(['careGuidesAdmin', careGuideId]);
  const data = {
    ...state.entities.getIn(['userProfiles', careGuide?.owner])?.profile,
    status: careGuide?.account.subscription_status,
    care_partner_tags: careGuide?.care_partner_tags,
  };

  const adminPartnerClassesAdmin = adminPartnerClass
    ? adminPartnerClass
        .map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['adminPartnerClassesAdmin', x]),
              schema.adminPartnerClassAdmin,
              state.entities.toJS()
            ),
          };
        })
        .toArray()
        .map((x) => {
          return {
            ...x,
          };
        })
    : [];

  return {
    careGuideId,
    partnershipId,
    data,
    adminPartnerClassesAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partershipId, careguideId, cb) => {
      dispatch(loadCareGuideAdmin(partershipId, careguideId, cb));
    },
    loadTags: (partnershipId, cb) => {
      dispatch(loadAdminPartnerClassPartnershipAdmin(partnershipId, cb));
    },
  };
};

const SmsConversationProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsConversationProfile);

export default SmsConversationProfileContainer;
